module.exports = __webpack_public_path__ + "website/img/zs3.9f180bcb.jpeg";